// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
import { colorGuard, brandingGuard, languageInfoGuard, signInGuard, signUpGuard, socialSignInGuard, connectorTargetsGuard, customContentGuard, customUiAssetsGuard, partialPasswordPolicyGuard, mfaGuard } from './../foundations/index.js';
import { AgreeToTermsPolicy, SignInMode } from './custom-types.js';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    id: z.string().min(1).max(21),
    color: colorGuard,
    branding: brandingGuard,
    languageInfo: languageInfoGuard,
    termsOfUseUrl: z.string().max(2048).nullable().optional(),
    privacyPolicyUrl: z.string().max(2048).nullable().optional(),
    agreeToTermsPolicy: z.nativeEnum(AgreeToTermsPolicy).optional(),
    signIn: signInGuard,
    signUp: signUpGuard,
    socialSignIn: socialSignInGuard.optional(),
    socialSignInConnectorTargets: connectorTargetsGuard.optional(),
    signInMode: z.nativeEnum(SignInMode).optional(),
    customCss: z.string().nullable().optional(),
    customContent: customContentGuard.optional(),
    customUiAssets: customUiAssetsGuard.nullable().optional(),
    passwordPolicy: partialPasswordPolicyGuard.optional(),
    mfa: mfaGuard.optional(),
    singleSignOnEnabled: z.boolean().optional(),
});
const guard = z.object({
    tenantId: z.string().max(21),
    id: z.string().min(1).max(21),
    color: colorGuard,
    branding: brandingGuard,
    languageInfo: languageInfoGuard,
    termsOfUseUrl: z.string().max(2048).nullable(),
    privacyPolicyUrl: z.string().max(2048).nullable(),
    agreeToTermsPolicy: z.nativeEnum(AgreeToTermsPolicy),
    signIn: signInGuard,
    signUp: signUpGuard,
    socialSignIn: socialSignInGuard,
    socialSignInConnectorTargets: connectorTargetsGuard,
    signInMode: z.nativeEnum(SignInMode),
    customCss: z.string().nullable(),
    customContent: customContentGuard,
    customUiAssets: customUiAssetsGuard.nullable(),
    passwordPolicy: partialPasswordPolicyGuard,
    mfa: mfaGuard,
    singleSignOnEnabled: z.boolean(),
});
export const SignInExperiences = Object.freeze({
    table: 'sign_in_experiences',
    tableSingular: 'sign_in_experience',
    fields: {
        tenantId: 'tenant_id',
        id: 'id',
        color: 'color',
        branding: 'branding',
        languageInfo: 'language_info',
        termsOfUseUrl: 'terms_of_use_url',
        privacyPolicyUrl: 'privacy_policy_url',
        agreeToTermsPolicy: 'agree_to_terms_policy',
        signIn: 'sign_in',
        signUp: 'sign_up',
        socialSignIn: 'social_sign_in',
        socialSignInConnectorTargets: 'social_sign_in_connector_targets',
        signInMode: 'sign_in_mode',
        customCss: 'custom_css',
        customContent: 'custom_content',
        customUiAssets: 'custom_ui_assets',
        passwordPolicy: 'password_policy',
        mfa: 'mfa',
        singleSignOnEnabled: 'single_sign_on_enabled',
    },
    fieldKeys: [
        'tenantId',
        'id',
        'color',
        'branding',
        'languageInfo',
        'termsOfUseUrl',
        'privacyPolicyUrl',
        'agreeToTermsPolicy',
        'signIn',
        'signUp',
        'socialSignIn',
        'socialSignInConnectorTargets',
        'signInMode',
        'customCss',
        'customContent',
        'customUiAssets',
        'passwordPolicy',
        'mfa',
        'singleSignOnEnabled',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
